import type { FaireProductEntity } from "../../entity_types/product";

export const p_7rzdpeq5kt: FaireProductEntity = {
  token: "p_7rzdpeq5kt",
  type: "product",
  name: "Sweet & Savory Sea Salt",
  brandToken: "b_xhgxgkda5f",
  brandName: "Jar Masala",
  imageUrl:
    "https://cdn.faire.com/fastly/80199c3b8782e903c67024f728b6c14e9d4e5ad2a1524e7529c4b8172e406a14.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/33f4bcceaca920c903f22d329862ed84093e6fe87ba5737f1616f882329c3d1f.jpeg",
    "https://cdn.faire.com/fastly/a033a49a099889e1563c505e18c6f69334d292ffed07546d794f2fa57c449bc8.jpeg",
    "https://cdn.faire.com/fastly/d41c1af81a7f305c59f8e9a9ca931dd38ad934b960aa2c2f058f333170995944.jpeg",
    "https://cdn.faire.com/fastly/bd83f0f82339ec38f7f7b0ae3a664a5298446031f5bbffc9860467e9d6b63747.jpeg",
  ],
  priceDollars: 7.62,
  description:
    "Elevate your dishes with this versatile Sweet & Savory Sea Salt blend, featuring premium coarse sea salt mixed with natural cane sugar and savory spices. Ideal for caramelizing meats, roasting veggies, or adding a gourmet touch to popcorn and desserts, this blend balances rich, complex flavors for a perfect, satisfying finish. \n\nHow to Use Tips:\nPerfect as a finishing salt for all sorts of dishes, meats, or as a finishing salt on vegetables, potatoes, and desserts.\nExcellent on vegetables such as sweet potatoes, butternut squash, or root vegetables.\n\n4oz. | $5.50\nAromatic spices are roasted and blended in small batches to ensure optimal flavor and freshness.\nPremium, great quality ingredients blended with flavors in mind. \nGourmet blend by a women-owned artisanal spice company in Snellville, GA. \nHandcrafted in the USA from imported and local ingredients.\n\n*Wooden Spice Spoon included w/4oz. Jar",
  tags: [],
  msrpDollars: 15.23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:41.218Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
